export const BaseUrl = "https://sokindiyor.uz/imsoft/api";
